module.exports = __webpack_public_path__ + "static/slack-step3-812dcc3d2eef13d3fc0b40aa25461fb3.png";